export default __webpack_public_path__ + "static/media/promo_04.efb9e712.jpg";